$(document).ready(function () {
  $("#result2").hide();

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".scrollup").fadeIn();
    } else {
      $(".scrollup").fadeOut();
    }
  });

  $(".scrollup").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );
    return false;
  });
});

window.handleAddCourseBin = function (xhr, status, sectionId) {
  let resultElementId = document.getElementById(`result-${sectionId}`);
  let submitButton = document.getElementById(`submit-add-${sectionId}`);
  submitButton.classList.remove('processing');

  if (xhr.status === 200) {
    resultElementId.innerHTML = "";
    submitButton.innerHTML = "Added to Course Bin";
    showmodal2(`Section ${sectionId} has been placed in your Course Bin.`);
  } else {
    resultElementId.innerHTML = "Error Adding to Course Bin";

    submitButton.disabled = false;
    showmodal2(`Error adding section ${sectionId} to your Course Bin.`);
  }
}

window.disableAddCourseBin = function(sectionId) {
  let submitButton = document.getElementById(`submit-add-${sectionId}`);
  submitButton.disabled = true;
  submitButton.classList.add('processing');
}

function showmodal2(message) {
  document.getElementById("result2-p").innerHTML = message;
  $("#result2").dialog({ autoOpen: false });

  $("#result2").dialog("open");
  $(".ui-dialog-titlebar").hide();

  setTimeout("$('#result2').hide(); ", 1000);
  setTimeout("$('#result2').dialog('close'); ", 1000);
}
